import { render } from "./CustemurSlider.vue?vue&type=template&id=601b5521&scoped=true"
import script from "./CustemurSlider.vue?vue&type=script&lang=js"
export * from "./CustemurSlider.vue?vue&type=script&lang=js"

import "./CustemurSlider.vue?vue&type=style&index=0&id=601b5521&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601b5521"]])

export default __exports__